import { useLazyQuery } from '@apollo/client';
import {ORDERS} from "../orderTypeDefs";

export const useQueryHistory = (options?: any): any => (
  useLazyQuery(ORDERS, options)
);
